import { render, staticRenderFns } from "./ReporteInstitucion.vue?vue&type=template&id=769c253d&scoped=true"
import script from "./ReporteInstitucion.vue?vue&type=script&lang=js"
export * from "./ReporteInstitucion.vue?vue&type=script&lang=js"
import style0 from "./ReporteInstitucion.vue?vue&type=style&index=0&id=769c253d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769c253d",
  null
  
)

export default component.exports